(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backed-by-science"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindTimeline = (root) => {
      if (!root || root.dataset.bbsBound === '1') return;
      const steps = root.querySelector('.s-backed-by-science__steps');
      const track = root.querySelector('.s-backed-by-science__track');
      const fill = root.querySelector('.s-backed-by-science__track-fill');
      const items = [...root.querySelectorAll('.s-backed-by-science__item')];
      if (!steps || !track || !fill || !items.length) return;
      root.dataset.bbsBound = '1';

      let ticking = false;

      const update = () => {
        ticking = false;
        const nums = items.map((item) => item.querySelector('.s-backed-by-science__num')).filter(Boolean);
        if (!nums.length) return;

        const stepsRect = steps.getBoundingClientRect();
        const first = nums[0].getBoundingClientRect();
        const last = nums[nums.length - 1].getBoundingClientRect();
        const firstCenter = first.top + first.height / 2 - stepsRect.top;
        const lastCenter = last.top + last.height / 2 - stepsRect.top;
        track.style.top = `${firstCenter}px`;
        track.style.height = `${Math.max(0, lastCenter - firstCenter)}px`;

        const trigger = window.innerHeight * 0.38;
        let active = 0;
        nums.forEach((num, index) => {
          const rect = num.getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          if (center <= trigger) active = index;
        });

        const activeRect = nums[active].getBoundingClientRect();
        const activeCenter = activeRect.top + activeRect.height / 2 - stepsRect.top;
        const fillPct =
          lastCenter === firstCenter ? 0 : (activeCenter - firstCenter) / (lastCenter - firstCenter);
        fill.style.height = `${Math.max(0, Math.min(1, fillPct)) * 100}%`;

        items.forEach((item, index) => {
          item.classList.toggle('is-active', index === active);
        });
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    };

    const init = () => {
      document.querySelectorAll('.s-backed-by-science').forEach(bindTimeline);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('.s-backed-by-science') || event.target.closest('.s-backed-by-science');
      if (root) {
        delete root.dataset.bbsBound;
        bindTimeline(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindHero = () => {
      document.querySelectorAll('.s-hero-banner__container[data-hero-link]').forEach((container) => {
        if (container.dataset.heroBound === '1') return;
        container.dataset.heroBound = '1';

        container.addEventListener('click', (event) => {
          if (event.target.closest('a, button')) return;
          const href = container.getAttribute('data-hero-link');
          if (!href) return;
          if (href.startsWith('#')) {
            const id = href.slice(1);
            const el =
              document.getElementById(id) ||
              document.querySelector('.product-information') ||
              document.querySelector('.buy-buttons-block');
            if (el) {
              event.preventDefault();
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
          }
          window.location.href = href;
        });
      });

      document.querySelectorAll('.s-hero-banner__button[data-scroll-to]').forEach((btn) => {
        if (btn.dataset.scrollBound === '1') return;
        btn.dataset.scrollBound = '1';
        btn.addEventListener('click', (event) => {
          const targetId = btn.dataset.scrollTo;
          if (!targetId) return;
          const el =
            document.getElementById(targetId) ||
            document.querySelector('.product-information') ||
            document.querySelector('.buy-buttons-block') ||
            document.querySelector(`[id$="__${CSS.escape(targetId)}"]`) ||
            document.querySelector(`[id$="${CSS.escape(targetId)}"]`);
          if (!el) return;
          event.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHero, { once: true });
    } else {
      bindHero();
    }

    document.addEventListener('shopify:section:load', bindHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindGrid = (root) => {
      if (!root || root.dataset.icgBound === '1') return;
      root.dataset.icgBound = '1';

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-inview');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(root);
    };

    const init = () => {
      document.querySelectorAll('.s-image-content-grid').forEach(bindGrid);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('.s-image-content-grid') || event.target.closest('.s-image-content-grid');
      if (root) {
        delete root.dataset.icgBound;
        bindGrid(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
